module.exports = __webpack_public_path__ + "static/media/AgreementV.2014d681.svg";